<div class="modal-overlay" [class.open]="isOpen" (click)="onClose()">
    <div class="modal-container" [class.add-budget-mode]="isAddBudgetOpen" (click)="onContainerClick($event)">
        <!-- Budget Status List View -->
        <ng-container *ngIf="!isAddBudgetOpen">
            <div class="modal-header">
                <h2 class="modal-title">Budget Status</h2>
                <button class="done-btn" (click)="onClose()">Done</button>
            </div>

            <div class="modal-body">
                <div *ngIf="isLoading" class="loading-container">
                    <div class="loader"></div>
                    <p>Loading budgets...</p>
                </div>

                <div class="budget-list" *ngIf="!isLoading">
                    <div class="budget-item" *ngFor="let item of budgetItems">
                        <div class="budget-item__left">
                            <div class="budget-item__info">
                                <div class="budget-item__category">{{ item.category }}</div>
                                <div class="budget-item__spent">Spent {{ item.spentAmount }}</div>
                            </div>
                            <div class="budget-item__progress-section">
                                <div class="progress-bar-container">
                                    <div class="progress-bar"
                                        [style.width.%]="item.percentage > 100 ? 100 : item.percentage"
                                        [class.exceeded]="item.percentage > 100">
                                    </div>
                                </div>
                                <span class="percentage-text" [class.exceeded]="item.percentage > 100">{{
                                    item.percentage
                                    }}%</span>
                            </div>
                        </div>

                        <div class="budget-item__right">
                            <div class="budget-item__total">{{ item.totalAmount }}</div>
                            <div class="budget-item__actions">
                                <button class="action-btn pin-btn" [class.pinned]="item.isPinned"
                                    (click)="togglePin(item)">
                                    {{ item.isPinned ? 'Pinned' : 'Pin' }}
                                </button>
                                <button class="action-btn edit-btn" (click)="onEdit(item)">Edit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="add-budget-btn" (click)="onAddNewBudget()">
                    Add New Budget
                    <img src="assets/icons/arrow-right.svg" alt="arrow-right">
                </button>
            </div>
        </ng-container>

        <!-- Add New Budget View -->
        <ng-container *ngIf="isAddBudgetOpen">
            <div class="modal-header add-budget-header">
                <button class="cancel-btn" (click)="isAddBudgetOpen = false">Cancel</button>
                <h2 class="modal-title">Add New Budget</h2>
                <button class="save-btn" (click)="onSaveBudget()">Save</button>
            </div>

            <div class="modal-body add-budget-body">
                <div class="form-group">
                    <label class="form-label">Budget Amount</label>
                    <div class="amount-input-wrapper">
                        <span class="currency-symbol">₹</span>
                        <input type="text" class="amount-input" placeholder="700,425.35">
                        <span class="currency-code">INR</span>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Select Categories</label>
                    <div class="custom-select-container" [class.active]="isDropdownOpen" #dropdownRef>
                        <div class="select-trigger" (click)="isDropdownOpen = !isDropdownOpen" tabindex="0">
                            <span class="selected-value">{{ selectedCategory || '' }}</span>
                            <div class="select-arrow">
                                <img src="assets/icons/direction-down.svg" alt="chevron-down">
                            </div>
                        </div>
                        <div class="dropdown-list" *ngIf="isDropdownOpen">
                            <div class="dropdown-item" *ngFor="let cat of categories"
                                (click)="selectedCategory = cat; isDropdownOpen = false"
                                [class.selected]="selectedCategory === cat">
                                {{cat}}
                            </div>
                        </div>
                    </div>
                    <p class="helper-text" [style.visibility]="isDropdownOpen ? 'hidden' : 'visible'">Select or enter a
                        category</p>
                </div>
            </div>
        </ng-container>
    </div>
</div>